import { render, staticRenderFns } from "./IndexSearchStaticFields.vue?vue&type=template&id=665fc003&scoped=true&"
import script from "./IndexSearchStaticFields.vue?vue&type=script&lang=js&"
export * from "./IndexSearchStaticFields.vue?vue&type=script&lang=js&"
import style0 from "./IndexSearchStaticFields.vue?vue&type=style&index=0&id=665fc003&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665fc003",
  null
  
)

export default component.exports